class CodigoBarrasNcmController extends AbstractController
  @$inject = ['$injector', '$scope', 'pathService', 'codigoBarrasNcmService']

  constructor: ($injector, @scope, pathService, @codigoBarrasNcmService) ->
    super($injector)
    @url = pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/processo-tipo/';
    @loadingTracker = @promiseTracker()
    @listOfCodigoBarrasNcm = []
    @page = 1
    @consultar(@page,{})

  consultar: (page, filtro) ->
    @loadingTracker.addPromise(@codigoBarrasNcmService.search({page: page, consulta: filtro},
        (data) =>
          data = data.data

          @pagination =
            page: page
            total: data.total_pages
            perPage: 1

          @listOfCodigoBarrasNcm = data.items
      )
    )


angular.module("eficienciaFiscalModule").controller('codigoBarrasNcmController', CodigoBarrasNcmController)